<template>
  <v-dialog v-model="dialog" width="700">
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        <v-icon color="green" class="mr-2">mdi-greenhouse</v-icon>
        {{ nomeSerra }}
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-switch
                v-model="mostra_esauriti"
                label="Mostra esauriti"
                color="green"
                dense
                hide-details
                class="mt-0 pt-0 text-body-2"
              />
            </div>
          </template>
          <span>Solo quelli esauriti di recente (ultime 12 settimane)</span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-progress-linear v-if="loading" indeterminate class="mb-2" />
        <template v-else>
          <v-list
            v-if="colture.length"
            dense
            class="py-0"
            style="max-height: 55vh; overflow-y: auto"
          >
            <template v-for="(gruppo, index) in gruppi">
              <SerraProdottoGruppoElement
                :key="gruppo.id_prodotto"
                :gruppo="gruppo"
                @cambia_stato="onColturaCambiata()"
              />
              <v-divider
                v-if="index < gruppi.length - 1"
                :key="gruppo.id_prodotto + '-div'"
                class="my-1"
              />
            </template>
          </v-list>
          <div v-else class="text-center grey--text py-8">
            <v-icon color="grey lighten-1" size="40"
              >mdi-flask-empty-outline</v-icon
            >
            <div class="text-caption mt-2">
              Nessun prodotto/lotto presente in questa serra
            </div>
          </div>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import SerraProdottoGruppoElement from "./SerraProdottoGruppoElement.vue";

export default {
  name: "SerraDettaglioLottiDialog",
  components: { SerraProdottoGruppoElement },
  data() {
    return {
      dialog: false,
      loading: false,
      id_serra: null,
      colture: [],
      mostra_esauriti: false,
    };
  },
  computed: {
    nomeSerra() {
      let serra = this.$store.getters.getSerraById(this.id_serra);
      return serra ? serra.nome : "Serra";
    },
    // Raggruppa per prodotto: lo stesso prodotto può avere più lotti/colture
    // nella stessa serra (fornitori/consegne diverse).
    gruppi() {
      const map = {};
      const order = [];
      for (const item of this.colture) {
        const id = item.coltura.id_prodotto;
        if (!map[id]) {
          map[id] = { id_prodotto: id, items: [] };
          order.push(id);
        }
        map[id].items.push(item);
      }
      return order.map((id) => map[id]);
    },
  },
  watch: {
    mostra_esauriti() {
      this.carica();
    },
  },
  methods: {
    open(id_serra) {
      this.id_serra = id_serra;
      this.dialog = true;
      this.carica();
    },
    onColturaCambiata() {
      this.carica();
      // La cache hover del canvas (mappa aziendale) non conosce lo
      // spostamento/esaurimento appena avvenuto: il genitore la invalida.
      this.$emit("aggiornato");
    },
    carica() {
      if (!this.id_serra) return;
      this.loading = true;
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/lotti/serra/" +
        this.id_serra +
        "/colture";
      if (this.mostra_esauriti) {
        url += "?includi_esauriti=1";
      }
      let auth = this.$store.getters.get_credential;
      axios
        .get(url, { auth: auth })
        .then((res) => {
          this.colture = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
